import Vue from "vue";
import Router from "vue-router";

import newYearDay from "./newYearDay";
import triennial from "./triennial";
import dkhd from "./dkhd";
import riverMountain from "./riverMountain";
import riverMountain2 from "./riverMountain-2";
import riverMountain3 from "./riverMountain-3";
import hlw from "./hlw";
import fourth from "./fourth";
import anniverSary from "./anniversary";
import million from "./million";
import beer from "./beer";
import webcast from "./webcast";
import doubleDan from "./doubleDan";
import questionnaire from "./questionnaire";
import assignation from "./assignation";
import aprilfoolsday from "./aprilfoolsday";
import fiveAnniversary from "./fiveAnniversary";
import sixAnniversary from "./sixAnniversary";
import anniversaryBadge from "./anniversaryBadge";
import fifthReport from "./5thReport";
import recall from "./recall";
import midAutumn from "./midAutumn";
import springFestival from "./springFestival";
import snail_5thLeading from "./snail_5thLeading";
import snail_5thSpecial from "./snail_5thSpecial";
import doubleFestival from "./doubleFestival";
import nyf from "./nyf";
import ending from "./ending";
import springFestivalActive from "./springFestivalActive";
import sixthAnniveRecall from "./sixthAnniveRecall";
import wordHunt from "./wordHunt";
import yayaLand from "./yayaLand";
import midAutumnRecall from "./midAutumnRecall";

// import doubleFestivalTW from './doubleFestival-tw'
Vue.use(Router);

const router = new Router({
    mode: "history",
    base: "/snail",
    routes: [
        ...newYearDay,
        ...triennial,
        ...dkhd,
        ...riverMountain,
        ...riverMountain2,
        ...riverMountain3,
        ...hlw,
        ...fourth,
        // ...anniverSary,
        ...million,
        ...beer,
        ...webcast,
        ...doubleDan,
        ...questionnaire,
        ...assignation,
        ...aprilfoolsday,
        ...fiveAnniversary,
        ...sixAnniversary,
        ...anniversaryBadge,
        ...fifthReport,
        ...recall,
        ...midAutumn,
        ...snail_5thLeading,
        ...snail_5thSpecial,
        ...doubleFestival,
        ...nyf,
        ...ending,
        ...springFestival,
        ...springFestivalActive,
        ...sixthAnniveRecall,
        ...wordHunt,
        ...yayaLand,
        ...midAutumnRecall,
        // ...doubleFestivalTW
    ],
});

export default router;



// WEBPACK FOOTER //
// ./src/router/snail/index.js